/** @file puppetTransform: the whole-puppet rotation, body facing times tilt. */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import { quatFromYawPitchRoll } from '@zilo/pose3d-math/quat/quatFromYawPitchRoll';
import { quatMul } from '@zilo/pose3d-math/quat/quatMul';
import type { PoseParams } from '@zilo/pose3d-pose/contract';
import { tiltOf } from '@zilo/pose3d-pose/chain/tiltOf';

/**
 * `face * tilt`: `face` = yaw `bodyFacingDeg` (verbatim), `tilt` = `tiltOf(params)` (21.9; identity when none). The
 * rotation part of the body transform, for body-space directions (event offsets, IK targets); positions also turn about
 * each root's pivot (`chainPose`).
 */
export function puppetTransform(params: PoseParams): Quat {
  return quatMul(quatFromYawPitchRoll(params.bodyFacingDeg, 0, 0), tiltOf(params) ?? [0, 0, 0, 1]);
}
